export default __webpack_public_path__ + "static/4-matching-game-acd6942875849b8e03a8dcd85bb1d712.jpg";